module.exports = __webpack_public_path__ + "img/CM-MC-25-Audi-Lifestyle.763cb35f.jpg";